<template>
  <div v-if="!showNoDiagnoseFoundModal" id="outer">
    <div id="left-uebersicht">
      <UebersichtEingaben></UebersichtEingaben>
    </div>
    <VorgeschlageneDiagnoseComponent id="vorgeschlagene-diagnose"/>
    <DiagnoseAuswahl id="diagnose-auswahl"/>
  </div>
  <div v-else>
  </div>
</template>

<script>
import UebersichtEingaben from "./UebersichtEingabenComponent";
import VorgeschlageneDiagnoseComponent from "./VorgeschlageneDiagnoseComponent";
import DiagnoseAuswahl from "./DiagnoseAuswahl";
import {mapGetters} from "vuex";

export default {
  name: "DiagnosenRoot",
  components: {
    DiagnoseAuswahl,
    VorgeschlageneDiagnoseComponent,
    UebersichtEingaben
  },
  computed: {
    ...mapGetters('cdss', ['showNoDiagnoseFoundModal'])
  }
}
</script>

<style scoped>
#outer {
  display: grid;
  grid-template-areas:
      "left-uebersicht vorgeschlagene-diagnose"
      "left-uebersicht diagnose-auswahl"
      "left-uebersicht diagnose-auswahl";
  grid-template-rows: auto auto 1fr;
  grid-template-columns: 1fr 2fr;
  height: 100%;
}

#left-uebersicht {
  grid-area: left-uebersicht;
}


#vorgeschlagene-diagnose {
  grid-area: vorgeschlagene-diagnose;
}

#diagnose-auswahl {
  grid-area: diagnose-auswahl;
}

</style>
